import { Vector2 } from "three";
import { coordinateSystem } from "./CoordinateSystem";

const zoomFaktor = 1.15;

export function zoomIn(mousePos: Vector2 = undefined) {
  coordinateSystem().zoomTo(zoomFaktor, mousePos);
}

export function zoomOut(mousePos: Vector2 = undefined) {
  coordinateSystem().zoomTo(1 / zoomFaktor, mousePos);
}

export function Zoom({ setDollyDirty }) {
  return (
    <div className="zoom-menu bordered" role="group" aria-label={I18N("aria::Zoom-Steuerung")} data-group-key="Zoom">
      <div className="zoom-buttons-row">
        <button
          className="secondary-button zoom-button zoom-button-minus"
          aria-label={I18N("aria::Herauszoomen")}
          title={I18N("aria::Herauszoomen")}
          data-button-key="zoom-out"
          onClick={() => {
            zoomIn();
            setDollyDirty();
            APP.logUserAction({ action: "clickZoom" }, { cached: true, stateChange: false });
          }}
        >
          <span aria-hidden="true">&minus;</span>
        </button>
        <span className="text zoom-label" aria-hidden="true">
          Zoom
        </span>
        <button
          className="secondary-button zoom-button zoom-button-plus"
          aria-label={I18N("aria::Hineinzoomen")}
          title={I18N("aria::Hineinzoomen")}
          data-button-key="zoom-in"
          onClick={() => {
            zoomOut();
            setDollyDirty();
            APP.logUserAction({ action: "clickZoom" }, { cached: true, stateChange: false });
          }}
        >
          <span aria-hidden="true">+</span>
        </button>
      </div>
      <button
        className="zoom-reset-button"
        aria-label={I18N("aria::Zoom zurücksetzen")}
        title={I18N("aria::Zoom zurücksetzen")}
        data-button-key="zoom-reset"
        onClick={() => {
          coordinateSystem().resetZoom();
          setDollyDirty();
          APP.logUserAction({ action: "resetZoom" }, { cached: true, stateChange: false });
        }}
      >
        {I18N("aria::Zoom zurücksetzen")}
      </button>
    </div>
  );
}
